<div class="portrait-container">
    <div class="portrait-notice">
        <p class="title">PLEASE EXPERIENCE IN PORTRAIT VIEW</p>
        <p class="body">EXPERIENCE WAS NOT BUILT FOR LANDSCAPE</p>
    </div>
</div>
